export type EmployerJPState = 'draft' | 'pending_approval' | 'open' | 'offline' | 'closed';

/**
 * Returns the JP state based on the JP status_key value
 * @param statusKey - The JP status_key value
 * @returns The corresponding JP state: 'draft', 'pending_approval', 'open', 'offline', or 'closed'
 */
export function getEmployerJPState(statusKey?: string): EmployerJPState {
  if (statusKey === 'jp_draft') {
    return 'draft';
  }

  if (statusKey === 'jp_approval') {
    return 'pending_approval';
  }

  if (statusKey === 'jp_screening' || statusKey === 'jp_shortlist_formation' || statusKey === 'jp_shortlist_sent') {
    return 'open';
  }

  if (statusKey === 'jp_suspended') {
    return 'offline';
  }

  // jp_closed_won, jp_closed_lost, or any other status
  return 'closed';
}
